<style scoped lang="scss" type="text/scss">
.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.el-col {
    padding: 10px;
    border-radius: 4px;
}
</style>

<template>
    <el-dialog
        :title="'正在' + (isUpdate ? '更新' : '添加') + '成果信息'"
        :close-on-click-modal="false"
        @closed="reset"
        :visible.sync="visibleSync"
        width="70%">
        <el-form :model="achievementInfo" :rules="rules" ref="form" label-width="90px" label-position="left">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="成果分类" prop="type" >
                        <team-achievement-selector :disabled="isUpdate" v-model="achievementInfo.type" placeholder="请选择成果分类">
                        </team-achievement-selector>
                    </el-form-item>
                </el-col>
            </el-row>

            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().OFFERING_COURSES">
            <h3 v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().OFFERING_COURSES">开设课程</h3>
            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().OFFERING_COURSES">

            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().OFFERING_COURSES">
                <el-col :span="24">
                    <el-form-item label-width="150px" label="出版物信息" prop="offering_courses_name">
                        <el-input v-model="achievementInfo.offering_courses_name" placeholder="请填写出版物名称、出版社、出版日期，并用顿号隔开"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PATENT">
            <h3 v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PATENT">专利</h3>
            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PATENT">
            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PATENT">
                <el-col :span="12">
                    <el-form-item label="专利名称" prop="patent_name">
                        <el-input v-model="achievementInfo.patent_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="专利号" prop="patent_id">
                        <el-input v-model="achievementInfo.patent_id"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PATENT">
                <el-col :span="12">
                    <el-form-item label="专利类别" prop="patent_kind">
                        <el-input v-model="achievementInfo.patent_kind"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="取得时间" prop="patent_get_time">
                        <el-date-picker class="full-width"
                                        v-model="achievementInfo.patent_get_time"
                                        type="month" value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().SOFTWARE_COPYRIGHT">
            <h3 v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().SOFTWARE_COPYRIGHT">软件著作权</h3>
            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().SOFTWARE_COPYRIGHT">
            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().SOFTWARE_COPYRIGHT">
                <el-col :span="12">
                    <el-form-item label-width="150px" label="软件著作权名称" prop="software_copyright_name">
                        <el-input v-model="achievementInfo.software_copyright_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label-width="150px" label="软件著作权登记号" prop="software_copyright_id">
                        <el-input v-model="achievementInfo.software_copyright_id"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().SOFTWARE_COPYRIGHT">
                <el-col :span="12">
                    <el-form-item label="取得时间" prop="software_copyright_get_time">
                        <el-date-picker class="full-width"
                                        v-model="achievementInfo.software_copyright_get_time"
                                        type="month" value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PAPER">
            <h3 v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PAPER">论文</h3>
            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PAPER">

            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PAPER">
                <el-col :span="12">
                    <el-form-item label="论文名称" prop="paper_name">
                        <el-input v-model="achievementInfo.paper_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="期刊" prop="paper_journal_name">
                        <el-input v-model="achievementInfo.paper_journal_name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().PAPER">
                <el-col :span="12">
                    <el-form-item label="期刊级别" prop="paper_journal_rank">
                        <el-input v-model="achievementInfo.paper_journal_rank"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="取得时间" prop="paper_journal_get_time">
                        <el-date-picker class="full-width"
                                        v-model="achievementInfo.paper_journal_get_time"
                                        type="month" value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().OTHER_AWARDS">
            <h3 v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().OTHER_AWARDS">
                大赛参赛作品取得其他科技竞赛奖项</h3>
            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().OTHER_AWARDS">

            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().OTHER_AWARDS">
                <el-col :span="12">
                    <el-form-item label-width="150px" label="大赛参赛作品取得其他科技竞赛奖项名称" prop="other_awards_name">
                        <el-input v-model="achievementInfo.other_awards_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label-width="200px" label="级别（校级、省市、国家）" prop="other_awards_rank">
                        <el-input v-model="achievementInfo.other_awards_rank"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().OTHER_AWARDS">
                <el-col :span="12">
                    <el-form-item label-width="150px" label="奖项名" prop="other_awards_prize_name">
                        <el-input v-model="achievementInfo.other_awards_prize_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="取得时间" prop="other_awards_get_time">
                        <el-date-picker class="full-width"
                                        v-model="achievementInfo.other_awards_get_time"
                                        type="month" value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().TEACHING_AWARD">
            <h3 v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().TEACHING_AWARD">教学成果奖</h3>
            <br v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().TEACHING_AWARD">

            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().TEACHING_AWARD">
                <el-col :span="12">
                    <el-form-item label="项目名" prop="teaching_award_name">
                        <el-input v-model="achievementInfo.teaching_award_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="奖项名" prop="teaching_award_prize_name">
                        <el-input v-model="achievementInfo.teaching_award_prize_name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row v-if="achievementInfo.type === TEAM_ACHIEVEMENT_VALUE_MAP().TEACHING_AWARD">
                <el-col :span="12">
                    <el-form-item label="级别" prop="teaching_award_rank">
                        <el-input v-model="achievementInfo.teaching_award_rank"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="取得时间" prop="teaching_award_get_time">
                        <el-date-picker class="full-width"
                                        v-model="achievementInfo.teaching_award_get_time"
                                        type="month" value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="confirm()" :loading="requesting">保存</el-button>
                <el-button @click="cancel()">取消</el-button>
                <el-button v-if="deletable" type="danger" style="float: right;" @click="remove()"
                           :loading="deleteRequesting">删除
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import TwoColsRow from '../../../../../components/el-form-item-aux/two-cols-row/index';
import TeamAchievementSelector from '../../../../sub-components/team-achievement-selector';
import {TEAM_ACHIEVEMENT_VALUE_MAP} from '../../../../../constant/team-achievement.js';
import {handleTeamAchievementUnit} from "../../../../../utils/data-handler";

export default {
    name: '',
    components: {
        TwoColsRow,
        TeamAchievementSelector
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        isUpdate: {
            type: Boolean,
            default: false
        },
        deletable: {
            type: Boolean,
            default: false
        },
        id: {   //team_achievement的序号
            type: Number,
            default: null
        }
    },
    watch: {
        visible(visible) {
            this.visibleSync = visible;
            if (!visible) return;
            const id = this.id;
            if (id === null || id === undefined) {
                this.achievementInfo = {};
            } else {
                this.$store.dispatch('team/loadAchievementInfo', {
                    id
                }).then(response => {
                    // this.achievementInfo = response.data;
                    this.achievementInfo = handleTeamAchievementUnit(response.data);
                });
            }
        },
        visibleSync(visibleSync) {
            this.$emit('update:visible', visibleSync);
        }
    },
    data() {
        return {
            visibleSync: null,
            achievementInfo: {},
            requesting: false,
            deleteRequesting: false,
            rules: {
                type: [
                    {required: true, message: '成果类型不能为空', trigger: 'blur'}
                ],
                offering_courses_name: [
                    {required: true, message: '出版物信息不能为空', trigger: 'blur'}
                ],
                patent_name: [
                    {required: true, message: '专利名称不能为空', trigger: 'blur'}
                ],
                patent_id: [
                    {required: true, message: '专利号不能为空', trigger: 'blur'}
                ],
                patent_kind: [
                    {required: true, message: '专利类别不能为空', trigger: 'blur'}
                ],
                patent_get_time: [
                    {required: true, message: '取得时间不能为空', trigger: 'blur'}
                ],
                software_copyright_name: [
                    {required: true, message: '软件著作权名称不能为空', trigger: 'blur'}
                ],
                software_copyright_id: [
                    {required: true, message: '软件著作权登记号不能为空', trigger: 'blur'}
                ],
                software_copyright_get_time: [
                    {required: true, message: '取得时间不能为空', trigger: 'blur'}
                ],
                paper_name: [
                    {required: true, message: '论文名称不能为空', trigger: 'blur'}
                ],
                paper_journal_name: [
                    {required: true, message: '期刊不能为空', trigger: 'blur'}
                ],
                paper_journal_rank: [
                    {required: true, message: '期刊级别不能为空', trigger: 'blur'}
                ],
                paper_journal_get_time: [
                    {required: true, message: '取得时间不能为空', trigger: 'blur'}
                ],
                other_awards_name: [
                    {required: true, message: '大赛参赛作品取得其他科技竞赛奖项名称不能为空', trigger: 'blur'}
                ],
                other_awards_rank: [
                    {required: true, message: '级别（校级、省市、国家）不能为空', trigger: 'blur'}
                ],
                other_awards_prize_name: [
                    {required: true, message: '奖项名不能为空', trigger: 'blur'}
                ],
                other_awards_get_time: [
                    {required: true, message: '取得时间不能为空', trigger: 'blur'}
                ],
                teaching_award_name: [
                    {required: true, message: '项目名不能为空', trigger: 'blur'}
                ],
                teaching_award_prize_name: [
                    {required: true, message: '奖项名不能为空', trigger: 'blur'}
                ],
                teaching_award_rank: [
                    {required: true, message: '级别不能为空', trigger: 'blur'}
                ],
                teaching_award_get_time: [
                    {required: true, message: '取得时间不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    computed: {
        currentManagedTeamId() {
            return this.$store.state.team.currentManagedTeamId;
        }
    },
    methods: {
        TEAM_ACHIEVEMENT_VALUE_MAP() {
            return TEAM_ACHIEVEMENT_VALUE_MAP
        },
        remove() {
            this.$deleteConfirm().then(_ => {
                this.$normalRequest('team/deleteAchievement', {
                    id: this.id
                }, '删除成功', true, this, 'deleteRequesting').then(_ => {
                    this.$emit('need-reload');
                    this.reset();
                }).catch(_ => {
                });
            }).catch(_ => {
            });
        },
        confirm() {
            if (this.isUpdate) {
                this.update();
            } else {
                this.create();
            }
        },
        create() {
            this.handleTemplate('team/createAchievement', '创建成功');
        },
        update() {
            this.handleTemplate('team/updateAchievement', '更新成功');
        },
        handleTemplate(actionName, tip) {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                this.$normalRequest(actionName, {
                    team_id: this.currentManagedTeamId,
                    id: this.id,
                    ...this.achievementInfo
                }, tip, true, this, 'requesting').then(_ => {
                    this.afterSuccess();
                }).catch(_ => {
                });
            });
        },
        cancel() {
            this.reset();
        },
        afterSuccess() {
            this.$emit('need-reload');
            this.reset();
        },
        reset() {
            this.$refs.form.clearValidate();
            this.$refs.form.resetFields();
            this.visibleSync = false;
            this.achievementInfo = {};
        }
    }
};
</script>
